mutation ToggleWhatsAppIsEnabled {
    toggleWhatsAppIsEnabled {
        hasAuthToken
        isEnabled
        userPhoneNumber
    }
}
